<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'master-greyfabric',
  components: {
    PageTable,
  },
}
</script>
